import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Deliverables from 'components/Steps/Deliverables';
import {
  BubblesWrapper, BubbleElement, BubbleImage, BubbleName,
} from './styles';

class Bubbles extends React.Component {
  state = {
    showElems: false,
    elementsOrdered: [],
  };

  handleClick(element) {
    const { elements } = this.props;
    const elementsFiltered = elements.filter(elem => elem.id !== element.id);
    elementsFiltered.unshift(element);
    this.setState({ showElems: true, elementsOrdered: elementsFiltered });
  }

  render() {
    const { elements } = this.props;
    const { showElems, elementsOrdered } = this.state;
    const bubbles = _.map(elements, (element, i) => {
      const { name, icon, image } = element;
      const background = icon || image || '';

      return (
        <BubbleElement key={i} onClick={() => this.handleClick(element)}>
          {(background && background !== '') ? (
            <BubbleImage alt={name} src={background} />
          ) : (
            <BubbleImage className='with-initial'>
              {name.slice(0, 1)}
            </BubbleImage>
          )}
          <BubbleName>
            {name}
          </BubbleName>
        </BubbleElement>
      );
    });
    if (!showElems) {
      return (
        <BubblesWrapper>
          {bubbles}
        </BubblesWrapper>
      );
    }
    return (
      <Deliverables elements={elementsOrdered} onClose={() => this.setState({ showElems: false })} showClose />
    );
  }
}

Bubbles.propTypes = {
  elements: PropTypes.array.isRequired,
};

export default Bubbles;



// WEBPACK FOOTER //
// ./src/components/Steps/Bubbles/components/Bubbles.jsx